/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import { Heading, Paper, Size, BodyText, Button } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { ReactComponent as MethodIcon1 } from '../../../assets/icons/method_icon_1.svg';
import { ReactComponent as MethodIcon2 } from '../../../assets/icons/method_icon_2.svg';
import { ReactComponent as MethodIcon3 } from '../../../assets/icons/method_icon_3.svg';
import MethodThumbnail1 from '../../../assets/img/method_thumbnail_1.jpg';
import MethodThumbnail2 from '../../../assets/img/method_thumbnail_2.jpg';
import MethodThumbnail3 from '../../../assets/img/method_thumbnail_3.jpg';

interface MethodCardProps {
  method: number;
  theme: string | undefined;
  activeMethod: number;
  onMethodSelect: (method: number) => void;
  heading: string | undefined;
  subHeading: string | undefined;
  longDesc: string | undefined;
}

const MethodCard = ({ heading, subHeading, longDesc, method, theme, activeMethod, onMethodSelect }: MethodCardProps) => {
  const { t } = useTranslation();

  const images = [MethodThumbnail1, MethodThumbnail2, MethodThumbnail3];
  const icons = [<MethodIcon1 />, <MethodIcon2 />, <MethodIcon3 />];

  return (
    <Paper padding={Size.None} className={`method-grid__item ${theme}`} tabIndex={activeMethod > -1 ? -1 : 0}>
      <div
        className={`method-grid__item-image ${theme}`}
        onClick={() => onMethodSelect(method)}
        style={{ backgroundImage: `url(${images[method]})` }}
      >
        {icons[method]}
      </div>

      <div className="method-grid__item-content">
        <div>
          {heading && <Heading level={1}>{t(heading)}</Heading>}
          {isMobileOnly ? (
            <>{subHeading && <BodyText>{t(subHeading)}</BodyText>}</>
          ) : (
            <>
              {subHeading && <Heading level={3}>{t(subHeading)}</Heading>}
              {longDesc && <BodyText>{t(longDesc)}</BodyText>}
            </>
          )}
        </div>
        <div>
          <Button onClick={() => onMethodSelect(method)} buttonSize={Size.M}>
            {t('ui.method.simulate')}
          </Button>
        </div>
      </div>
    </Paper>
  );
};

export default MethodCard;
